import { types } from './actions';
import { TAB_TYPES } from './constants';

const initialState = {
  accounts: [],
  accountsCount: 0,
  activeTab: TAB_TYPES.ACCOUNTS,
  contacts: [],
  contactsCount: 0,
  filters: {},
  isBulkUpdateAccountsDrawerOpen: false,
  isSearching: false,
  pageNumber: 1,
  searchQuery: '',
  totalAccountsCount: 0,
  totalContactsCount: 0,
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case types.ACTIVE_TAB_SET:
      return {
        ...state,
        activeTab: payload.tab,
        isSearching: true,
        pageNumber: 1,
      };
    case types.PAGINATE:
      return {
        ...state,
        isSearching: true,
        pageNumber: payload.pageNumber,
        filters: payload.filters,
      };
    case types.SEARCH_ERROR:
      return {
        ...state,
        isSearching: false,
      };
    case types.SEARCH_REQUEST:
      return {
        ...state,
        isSearching: true,
        pageNumber: 1,
        searchQuery: payload.query,
      };
    case types.SEARCH_SUCCESS:
      return {
        ...state,
        accounts: payload.accounts,
        accountsCount: payload.accountsCount,
        contacts: payload.contacts,
        contactsCount: payload.contactsCount,
        isSearching: false,
        ...(!payload.query && {
          totalAccountsCount: payload.accountsCount,
          totalContactsCount: payload.contactsCount,
        }),
      };
    case types.SEARCH_PAGE_INIT:
      return {
        ...state,
        activeTab: payload.tab,
        isSearching: true,
        pageNumber: payload.page,
        searchQuery: payload.query,
      };
    case types.SEARCH_PAGE_INIT_SUCCESS:
      return {
        ...state,
        accounts: payload.accounts,
        accountsCount: payload.accountsCount,
        contacts: payload.contacts,
        contactsCount: payload.contactsCount,
        isSearching: false,
        totalAccountsCount: payload.accountsCount,
        totalContactsCount: payload.contactsCount,
      };
    case types.BULK_UPDATE_ACCOUNTS_DRAWER_OPEN:
      return {
        ...state,
        isBulkUpdateAccountsDrawerOpen: true,
      };
    case types.BULK_UPDATE_ACCOUNTS_DRAWER_CLOSE:
      return {
        ...state,
        isBulkUpdateAccountsDrawerOpen: false,
      };
    default:
      return state;
  }
};

const getScope = (state) => state.modules.contacts.searchPage;

// todo: use cached selector
export const getAccounts = (state) => getScope(state).accounts;

export const getAccountsCount = (state) => getScope(state).accountsCount;

export const getActiveTab = (state) => getScope(state).activeTab;

// todo: use cached selector
export const getContacts = (state) => getScope(state).contacts;

export const getContactsCount = (state) => getScope(state).contactsCount;

export const getTotalContactsCount = (state) =>
  getScope(state).totalContactsCount;

export const getTotalAccountsCount = (state) =>
  getScope(state).totalAccountsCount;

export const getPageNumber = (state) => getScope(state).pageNumber;

export const getSearchQuery = (state) => getScope(state).searchQuery;

export const getFilters = (state) => getScope(state).filters;

export const isSearching = (state) => getScope(state).isSearching;

export const getIsBulkUpdateAccountsDrawerOpen = (state) =>
  getScope(state).isBulkUpdateAccountsDrawerOpen;

export default reducer;
